import { createContext, useState, useEffect, useMemo } from 'react'

export const ReplaySessionContext = createContext()

export const ReplaySessionProvider = ({ 
    children, 
    sessionId, 
    task, 
    testCases,
    testList,
    starterCode, 
    events = [] 
}) => {
    
    const [session, setSession] = useState(null)

    // Calculate the Metadata (Start, End, Duration) from the raw events
    const sessionMeta = useMemo(() => {
        if (!events || events.length === 0) {
            return { startTime: 0, duration: 0 }
        }

        // Convert ISO strings to Epoch timestamps
        const timestamps = events.map(e => new Date(e.event_time).getTime())
        
        // Find the range
        const startTime = Math.min(...timestamps)
        const endTime = Math.max(...timestamps)
        
        return {
            startTime,
            endTime,
            duration: endTime - startTime
        }
    }, [events])

    useEffect(() => {
        if (task && sessionId) {
            setSession({
                id: sessionId, 
                task: task,
                test_code: testCases,
                test_list: testList,
                starterCode: starterCode, 
                duration: sessionMeta.duration, 
                startTime: sessionMeta.startTime,
                endTime: sessionMeta.endTime
            })
        }
    }, [task, testCases, sessionId, sessionMeta, starterCode]) 

    return (
        <ReplaySessionContext.Provider value={{ session, sessionLoading: false }}>
            {children}
        </ReplaySessionContext.Provider>
    )
}